module.exports = __webpack_public_path__ + "media/images/icon-teamwork-4a91cd5fafa12501cbf941b49c2b6d0f.svg";